import { doFetch, doPutFetch, doPostFetch, doDeleteFetch } from "./apiFetchHelper";
const API_URL = `/api/contact_methods`;

export function getContactMethods() {
  return doFetch(`${API_URL}`);
}

export function addContactMethods(data) {
  return doPutFetch(`${API_URL}`, data);
}

export function updateContactMethods(data) {
  return doPostFetch(`${API_URL}`, data);
}

export function deleteContactMethods(id) {
  return doDeleteFetch(`${API_URL}`, { id: id });
}

export default {
  getContactMethods,
  addContactMethods,
  updateContactMethods,
  deleteContactMethods,
};
